export default {
  properties: {
    tenantId: '1',
    serviceUrl: 'https://localhost:5001/hubs/resourcePlannerHub',
  },
};
